import { gql } from '@apollo/client';
import { AIRLINE_BASIC_FRAGMENT, AIRLINE_DETAIL_FRAGMENT, AIRLINE_COMPACT_FRAGMENT } from '../fragments';

// NOTE: Currently unused - the airlines page now uses GET_USER_AIRLINE_STATS instead
// TODO: Either remove this query or use it for a new general Airlines table (without user stats) in the future
export const LIST_AIRLINES_MINIMAL = gql`
  query ListAirlinesMinimal(
    $filter: AirlineFilterInput
    $sort: AirlineSortInput
    $pagination: PaginationInput
  ) {
    airlines(filter: $filter, sort: $sort, pagination: $pagination) {
      edges {
        node {
          ...AirlineBasic
        }
        cursor
      }
      pageInfo {
        currentPage
        totalPages
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${AIRLINE_BASIC_FRAGMENT}
`;

export const GET_AIRLINE_DETAIL = gql`
  query GetAirlineDetail($id: ID!) {
    airline(id: $id) {
      ...AirlineDetail
    }
  }
  ${AIRLINE_DETAIL_FRAGMENT}
`;

export const GET_AIRLINES_MINIMAL = gql`
  query GetAirlinesMinimal($ids: [ID!]!) {
    airlinesByIds(ids: $ids) {
      ...AirlineBasic
    }
  }
  ${AIRLINE_BASIC_FRAGMENT}
`;

export const GET_USER_AIRLINE_STATS = gql`
  query GetUserAirlineStats(
    $filter: UserAirlineStatsFilterInput
    $sort: UserAirlineStatsSortInput
    $pagination: PaginationInput
  ) {
    userAirlineStats(filter: $filter, sort: $sort, pagination: $pagination) {
      edges {
        node {
          airline {
            ...AirlineCompact
          }
          flightCountPast
          flightCountFuture
          totalDistanceKmPast
          totalDistanceKmFuture
          lastFlightDate
        }
        cursor
      }
      pageInfo {
        currentPage
        totalPages
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${AIRLINE_COMPACT_FRAGMENT}
`;

export const GET_USER_DISTINCT_COUNTS = gql`
  query GetUserDistinctCounts($includeFutureFlights: Boolean = true) {
    userDistinctCounts(includeFutureFlights: $includeFutureFlights) {
      airlineCount
      flightCount
      airportCount
    }
  }
`;

// TODO: Add more queries here as we migrate other components from REST to GraphQL
// Examples of field selection for different use cases:
//
// For dropdowns/selects (minimal fields):
//   airlines { edges { node { id shortname iataCode icaoCode } } }
//
// For compact lists (common fields):
//   airlines { edges { node { id shortname name iataCode icaoCode callsign } } } 